<ng-container *transloco="let t">
  <div class="result-trio-cat" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('trio.fiv') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="fiv" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('trio.felv') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="felv" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('trio.fcov') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="fcov" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('trio.note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="note"
          rows="6"
          placeholder="{{ t('Additional notes') }}"
        ></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
